export * from '@firebase/performance';
//# sourceMappingURL=index.esm.js.map
